import { debounce } from 'lodash'
import { t } from "react-multi-lang";
import Avatar from "@mui/material/Avatar";
import { Form, Button, Modal } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { createNotification } from "react-redux-notify";
import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";

import { getUserId } from "../../helpers/storage/user";
import { SpinnerLoader } from "../../components/Loader/ChatLoader";
import { newConversationStart } from "../../store/actions/ChatAction";
import ChatService from "../../helpers/services/communication/chatroom";
import { getErrorNotificationMessage } from "../helper/NotificationMessage";
const defaultProfile = "https://d9apl513jlx0u.cloudfront.net/public_assets/src/images/default/profile_placeholder.jpg";

const NewConversation = ({ show, close, onSuccess }) => {
  const dispatch = useDispatch();
  const [selected, setSelected] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const users = useSelector((state) => state.chat.newConverstaionUsers);

  useEffect(() => {
    if (show) {
      fetchUsers();
    } else {
      setSearchQuery('')
    }
    return () => {
      debouncedResults.cancel()
    }
  }, [show, searchQuery]);

  const observer = useRef();
  const lastElementRef = useCallback(
    (node) => {
      if (users.loading) return;
      if (observer.current) {
        observer.current.disconnect();
      }

      observer.current = new IntersectionObserver((entries) => {
        if (
          entries[0].isIntersecting &&
          users.data.metadata?.pagination?.page < users.data.metadata?.pagination?.numberOfPages
        ) {
          fetchUsers(users.data.metadata?.pagination?.page + 1);
        }
      });
      if (node) {
        observer.current.observe(node);
      }
    },
    [users.data.metadata, users.loading]
  );

  const fetchUsers = (page = 1) => {
    let query = { page };
    if (searchQuery) query = { ...query, q: searchQuery };
    dispatch(newConversationStart(query));
  };

  const handleSearchInputChange = (e) => {
    setSearchQuery(e.target.value)
  }

  const debouncedResults = useMemo(() => {
    return debounce(handleSearchInputChange, 500)
  }, [handleSearchInputChange])

  const setupChatroom = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      const chatroom = await ChatService.startChatroom(
        getUserId(),
        selected.id
      );
      onSuccess(chatroom);
    } catch (error) {
      dispatch(
        createNotification(getErrorNotificationMessage("Something went wrong!"))
      );
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <>
      <Modal
        size="md"
        centered
        show={show}
        onHide={close}
        className={`verify light'}`}
      >
        <Form translate='no'>
          <Modal.Body>
            <h2 className="text-center mt-4 bold mb-4">
              {t("start_converstaion")}
            </h2>
            <div className="searchpartview">
              <Form>
                <Form.Group className="" controlId="formSearch">
                  <Form.Control
                    type="search"
                    placeholder="Search..."
                    onChange={debouncedResults}
                  />
                  <Button
                    type="submit"
                    className="primary searchviewbtn"
                  ></Button>
                </Form.Group>
              </Form>
            </div>
            <div
              className="chatwindowlist"
              style={{ height: "512px", overflowY: "auto" }}
            >
              <ul>
                {users.data.result.length > 0 &&
                  users.data.result.map((user, i) => (
                    <li
                      key={`_chatroom_${user.id}`}
                      className={`${
                        user?.id === selected?.id ? "selected" : ""
                      }`}
                      onClick={() => {
                        setSelected(user);
                      }}
                      ref={
                        users.data.result.length === i + 1
                          ? lastElementRef
                          : null
                      }
                    >
                      <div className="imgchat">
                        <Avatar
                          src={user?.picture}
                          style={{ width: "64px", height: "64px", background: "none" }}
                          className=" img-fluid new-conversation-avatar"
                          alt='avtar'
                        >
                          <img
                            src={defaultProfile}
                            style={{ width: "64px", height: "64px" }}
                            alt="user profile"
                          />
                        </Avatar>
                      </div>
                      <div className="username-text">
                        <p>{`${user?.name}`}</p>
                      </div>
                    </li>
                  ))}
                {users.loading && <SpinnerLoader />}
              </ul>
            </div>
          </Modal.Body>
          <div className="footer">
            <Button variant="default" onClick={close}>
              {t("cancel")}
            </Button>
            <Button
              type="submit"
              variant="default"
              disabled={!selected}
              onClick={setupChatroom}
            >
              <div>
                {submitting && <div className="btn-spinner" />}
              </div>
              {t("start_converstaion")}
            </Button>
          </div>
        </Form>
      </Modal>
    </>
  );
};

export default NewConversation;
